import { request } from './../services/utils';
import download from 'downloadjs';
import { isSuccessfulResponse } from './responseHelpers';

// Files come straight from P4 now (no DPP re-streaming). P4 sets the
// `x-filename` + `Content-Disposition` headers (exposed via CORS); fetch as a
// blob so binary payloads (NACHA, XML, CSV) aren't mangled by JSON parsing.
// `accept` is needed for the endpoints that serve both JSON and a CSV export of
// the same records (held loans, daily processing payments/returns): the axios
// instance sends `Accept: application/json` by default, which would return the
// JSON representation instead of the file.
export const downloadReport = async (url, fileType, ensureContentPresent = true, accept = null) => {
    const response = await request(url, {
        responseType: 'blob',
        ...(accept ? { headers: { Accept: accept } } : {})
    });
    if (isSuccessfulResponse(response)) {
        download(response.data, response.headers["x-filename"]);
        return response.data;
    } else if(ensureContentPresent && response.status === 204) {
        return response.data;
    } else {
        throw new Error(`Server error downloading ${fileType} file`);
    }
};
